import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

/**
 * Wie mag de spelletjes die nog in beta staan.
 *
 * Eén rij per account, en de rij is de knop: klikken zet het vinkje om. Groen is
 * tester. De mod staat er met een geel "altijd" bij, want die komt er ook zonder
 * vinkje in; zie magBeta in logic/arcade.js.
 *
 * Je komt hier alleen uit het modgereedschap, en het kruisje brengt je daar weer
 * terug in plaats van naar de paal: dit is een lade van dat venster.
 */
export default function BetaTesters({ v }) {
  if (!v.showBeta) return null;
  return (
    <div className="gp-laag" style={{ position: 'fixed', inset: '0', background: 'rgba(36,27,58,.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 97, padding: '20px' }} onClick={v.closeBeta}>
      <div className="gp-venster gp-vast" style={{ width: 'min(440px,100%)', maxHeight: 'min(78vh,680px)', padding: '24px', display: 'flex', flexDirection: 'column', gap: '14px', boxSizing: 'border-box' }} onClick={v.stopProp}>

        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', flex: '0 0 auto' }}>
          <div style={{ fontSize: '19px', fontWeight: 700, lineHeight: 1.2, flex: '1 1 auto', minWidth: '0' }}>
            Betatesters
          </div>
          <button onClick={v.closeBeta} title="Sluiten" style={css(v.sluitStyle)}>
            <Kruis maat={22} />
          </button>
        </div>

        <div style={{ flex: '1 1 auto', minHeight: '0', overflow: 'auto', display: 'flex', flexDirection: 'column', gap: '8px', paddingRight: '2px' }}>
          {toList(v.betaLijst).map((b, $index) => (
            <React.Fragment key={$index}>
              <button onClick={b?.onClick} className="gp-btn gp-plat" title={b?.titel} aria-pressed={b?.label === 'tester'} disabled={b?.bezig} style={css(b?.rijStyle)}>
                <img alt="" src={b?.avatarUrl} style={{ width: '32px', height: '32px', imageRendering: 'pixelated', border: '2px solid var(--ink)', borderRadius: '8px', background: '#fff', display: 'block', flex: '0 0 auto' }} />
                <span style={css(b?.naamStyle)}><Interp v={b?.name} /></span>
                {b?.label ? <span style={css(b?.labelStyle)}><Interp v={b?.label} /></span> : null}
              </button>
            </React.Fragment>
          ))}
        </div>

        <div style={{ flex: '0 0 auto', display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {v.hasBetaFout ? (
            <span style={{ fontSize: '12px', fontWeight: 600, color: 'var(--fout)', lineHeight: 1.4 }}>
              <Interp v={v.betaFout} />
            </span>
          ) : null}
          <div style={{ fontSize: '12px', fontWeight: 700, color: 'var(--tekst-2)' }}>
            <Interp v={v.betaAantalLabel} />
          </div>
          <button onClick={v.closeBeta} className="gp-btn pink" style={css(v.hoofdKnopStyle)}>
            Klaar
          </button>
        </div>

      </div>
    </div>
  );
}
